/**
 * Folder Domain Types
 *
 * Defines strongly-typed folder domain models for Linkode Document Dashboard.
 * Implements path-based virtual folder organization.
 *
 * @module types/folder
 * @see SPEC-016 Requirements 2.1, 2.2
 */
/**
 * Factory function for creating type-safe FolderId values.
 *
 * @param id - The raw string identifier
 * @returns A branded FolderId value
 */
export function createFolderId(id) {
    return id;
}
/**
 * Maximum allowed folder nesting depth.
 * @see SPEC-016 Requirement 2.7
 */
export const MAX_FOLDER_DEPTH = 5;
/**
 * Characters that are not allowed in folder names.
 * @see SPEC-016 Requirement 2.5
 */
export const INVALID_FOLDER_NAME_CHARS = ['/', '\\', ':', '*', '?', '"', '<', '>', '|'];
/**
 * Regular expression pattern for validating folder names.
 * Matches any string that does NOT contain invalid characters.
 */
export const FOLDER_NAME_PATTERN = /^[^/\\:*?"<>|]+$/;
/**
 * Validates a folder name against the allowed character set.
 *
 * @param name - The folder name to validate
 * @returns true if the name is valid, false otherwise
 */
export function isValidFolderName(name) {
    if (!name || name.length === 0 || name.length > 64) {
        return false;
    }
    return FOLDER_NAME_PATTERN.test(name);
}
/**
 * Calculates the depth of a folder path.
 *
 * @param path - The folder path (e.g., "/projects/work/docs")
 * @returns The depth level (0 for root, 1 for first level, etc.)
 */
export function getFolderDepth(path) {
    if (!path || path === '' || path === '/') {
        return 0;
    }
    // Remove leading/trailing slashes and count segments
    const segments = path
        .replace(/^\/|\/$/g, '')
        .split('/')
        .filter(Boolean);
    return segments.length;
}
//# sourceMappingURL=folder.js.map